import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import {
  type IRepeatControllerWidget,
  RepeatControllerComponentType,
} from './IRepeatControllerWidget.ts';

export interface IRepeatControllerWidgetPreviewProps
  extends IWidgetComponentProps<IRepeatControllerWidget> {}

export function RepeatControllerWidgetPreview(
  props: IRepeatControllerWidgetPreviewProps,
) {
  const { widget } = props;
  const options = getWidgetProps(props);
  if (widget.kind === RepeatControllerComponentType.Input)
    return (
      <ConfigFormItem
        name={options.name}
        label={<RichTextAdvancedRender inline text={options.label} />}
        help={
          options.helpText ? (
            <RichTextAdvancedRender inline text={options.helpText} />
          ) : undefined
        }
        layout={{ hideVisualLabel: options.hideLabel }}
        readonly={options.readonly}
        widget={props.widget}
      >
        <NumberInput
          name={options.name}
          placeholder={options.placeholder}
          value={options.value as any}
          tabIndex={-1}
        />
      </ConfigFormItem>
    );

  return <div>Computed</div>;
}
